import AutomationHome from "./AutomationHome";
import AutomationDetail from "./AutomationDetail";
import AutomationCreate from "./AutomationCreate";
import RecentActivity from "./RecentAutomations";
import DeviceAutomations from "./DeviceAutomations";
import { AUTOMATION_PATHS } from "./paths";

export { AUTOMATION_PATHS } from "./paths";

// The Automation screens, for the router.
export const AUTOMATION_ROUTES = [
  { path: AUTOMATION_PATHS.HOME, component: AutomationHome },
  { path: AUTOMATION_PATHS.DETAIL, component: AutomationDetail },
  { path: AUTOMATION_PATHS.CREATE, component: AutomationCreate },
  { path: AUTOMATION_PATHS.EDIT, component: AutomationCreate },
  { path: AUTOMATION_PATHS.HISTORY, component: RecentActivity },
  { path: AUTOMATION_PATHS.DEVICE, component: DeviceAutomations },
];
